module.exports = __webpack_public_path__ + "static/media/1.f5a58bb3.jpg";